import { Link, useLocation } from "react-router-dom";
import React, {useEffect, useState} from "react";
import { categoryApi } from "../../api";

export default function Navbar() {
    const { pathname } = useLocation();
    const [categories, setCategories] = useState([]);
    const isMenuActive = (link) => {
        return link.href?.split("/")[1] == pathname.split("/")[1];
    };
    const isMenuParentActive = (menu) => {
        return menu.some((elm) => isMenuActive(elm));
    };
    const isMenuParentActive2 = (menu) => {
        return menu.some((elm) => isMenuParentActive(elm.links));
    };

    useEffect(() => {
        const loadCategories = async () => {
            try {
                const res = await categoryApi.getCategories();
                setCategories(res.data.categories || []); // örnek yapı: { categories: [...] }
            } catch (error) {
            }
        };

        loadCategories();
    }, []);

    return (
        <>
            <li className="menu-item">
                <Link to="/" className={`item-link ${isMenuActive("/") ? "menuActive" : ""}`}>
                    Home
                </Link>
            </li>


            <li className="menu-item">
                <Link to="/product-list" className={`item-link cursor-pointer ${isMenuActive("/products") ? "menuActive" : ""}`}>
                    Shop All
                </Link>
            </li>

            <li className="menu-item">
                <Link to="/product-list?gender=male" className={`item-link cursor-pointer ${isMenuActive("/products") ? "menuActive" : ""}`}>
                    Men
                </Link>
            </li>

            <li className="menu-item">
                <Link to="/product-list?gender=female" className={`item-link cursor-pointer ${isMenuActive("/products") ? "menuActive" : ""}`}>
                    Women
                </Link>
            </li>

            <li className="menu-item position-relative">
                <a href="/category-list" className="item-link">
                    Categories
                    <i className="icon icon-arr-down"/>
                </a>
                <div className="sub-menu sub-menu-style-1">
                    {/*<div className="menu-heading">Categories</div>*/}
                    <ul className="menu-list">
                        {categories.map((cat) => (
                            <li key={cat.slug}>
                                <Link
                                    to={`/product-list?category=${cat.slug}`}
                                    className={`menu-link-text link cursor-pointer ${isMenuActive(`/category/${cat.slug}`) ? "menuActive" : ""}`}
                                >
                                    {cat.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </li>

            {/*<li className="menu-item">*/}
            {/*    <Link to="/products" className={`item-link ${isMenuActive("/products") ? "menuActive" : ""}`}>*/}
            {/*        Discount*/}
            {/*    </Link>*/}
            {/*</li>*/}
        </>
    );
}
